export default "__VITE_ASSET__DCIjmLfG__"